import { render, staticRenderFns } from "./Garcom.vue?vue&type=template&id=5a70520d&scoped=true"
import script from "./Garcom.vue?vue&type=script&lang=js"
export * from "./Garcom.vue?vue&type=script&lang=js"
import style0 from "./Garcom.vue?vue&type=style&index=0&id=5a70520d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70520d",
  null
  
)

export default component.exports